export const selectElementText = (element: HTMLElement) => {
  const range = window.document.createRange()
  range.selectNodeContents(element)

  const selection = window.getSelection()
  if (selection) {
    selection.removeAllRanges()
    selection.addRange(range)
  }
  return selection
}

export const unselectText = () => window.getSelection()?.removeAllRanges()

export const applySelectionStyle = () => {
  const styleElement = window.document.createElement('style')
  styleElement.innerHTML = `
    ::selection {
      background: none;
      color: inherit;
    }
  `
  window.document.head.appendChild(styleElement)
  return styleElement
}

export const removeSelectionStyle = (styleElement: HTMLStyleElement) =>
  window.document.head.removeChild(styleElement)
